"use client";
import React from "react";

const AVATAR_COLORS = ["#dc2626", "#c2410c", "#b45309", "#15803d", "#0e7490", "#4f46e5", "#7e22ce", "#be185d"];

function colorForName(name) {
	let hash = 0;
	for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
	return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function initialsFor(name) {
	const parts = name.trim().split(/\s+/);
	const initials = `${parts[0]?.[0] || ""}${parts[1]?.[0] || ""}`.toUpperCase();
	return initials || "U";
}

export default function Avatar({ url, name = "Utilizator", size = 40, className = "" }) {
	if (url) {
		return <img src={url} alt='' className={`tf-avatar ${className}`} style={{ width: size, height: size }} />;
	}

	return (
		<div
			className={`tf-avatar tf-avatar-initials ${className}`}
			style={{ width: size, height: size, background: colorForName(name), fontSize: size * 0.4 }}>
			{initialsFor(name)}
		</div>
	);
}
